import React from 'react';
import { connect } from 'react-redux';
import ScriptLoader from './script-loader';
import { withError } from '../../shared/components/error-boundary';

class MoxieConcierge extends React.Component {
    constructor(props) {
        super(props);
        this.script = `https://asset.gomoxie.solutions/concierge/${props.storeEnvironment === 'production' ? 'hpi' : 'hpitest'}/client/concierge-client.js`;
        this.attributes = {
            'data-concierge-host':  'gomoxie.solutions',
            'concierge': 1,
            'data-client': `${props.storeEnvironment === 'production' ? 'hpi' : 'hpitest'}`
        }
    }

    componentDidMount() {
        const { cartInfo } = this.props;
        const cartTotal = (cartInfo.sTot || '0').split(',').join('')
        window.MoxieData.TotalQty = cartInfo.tQty;
        window.MoxieData.CartTotal = parseFloat(cartTotal);
    }

    componentDidUpdate(prevProps) {
        const { cartInfo } = this.props;
        if (prevProps.cartInfo.tQty !== cartInfo.tQty || prevProps.cartInfo.sTot !== cartInfo.sTot) {
            let cartTotal = (cartInfo.sTot || '0').split(',').join('')
            if (window.conciergeReady) {
                window.conciergeReady.then(() => {
                    window.GoMoxie.conciergeV2.updateSession({
                        currentCartValue: parseFloat(cartTotal),
                        currentCartItems: cartInfo.items
                    });
                })
            }
            window.MoxieData.TotalQty = cartInfo.tQty;
            window.MoxieData.CartTotal = parseFloat(cartTotal);
        }
    }

    render() {
        return(
            <ScriptLoader
                url={this.script}
                attributes={this.attributes}
                name='moxie'
            />
        )
    }
}

const mapStateToProps = (state) => ({
    cartInfo: state.cartInfo,
    storeEnvironment: state.storeEnvironment
});


export default connect(mapStateToProps, null)(withError(MoxieConcierge));